import axios from 'axios';
import { Message } from 'element-ui';
import { getGlobalConf } from '@/utils/grocer';
import * as requestRecord from './request-record';
import md5 from 'blueimp-md5';
const ROUTER_BASE_PATH = getGlobalConf().routerBasePath;
let CancelToken = axios.CancelToken;
const conf = getGlobalConf();
const formLinkPendingMap = new Map();
/** 不显示操作结果提示框的白名单 */
const msgWhiteList = [
    '/process/task/getProcessTaskList',
    '/process/processInstance/getProcessInstances',
    '/component/customForm/saveCalculation',
    '/cs/user/saveUser',
    'message/updMessage',
    'processFile/addProcessFileReadRecord',
    'mobile/attendance/queryClockInfoList',
    'application/model/queyApplicationGrantAuthorizationUsers',
    '/process/processSetting/checkUnPublicedProcessDefinition',
    '/cs/user/updateWorkPlantEntry',
    '/cs/user/updPortalMode',
    'pc/attendance/queryClockInfoList',
    '/component/customForm/checkDataLegitimacy',
    '/application/notice/saveMandatoryReminder',
    '/cs/user/loginPre',
    '/approval/instance/updCarbonCopy',
    '/pc/attendance/suggestionSearch',
    '/pc/attendance/contraryConvertGeocoder'
];

function defaultHeader () {
    return {};
};

const hasUrlInWhiteList = (url) => {
    return msgWhiteList.some(item => {
        return url.indexOf(item) !== -1;
    });
};

/**
 * 分析后端返回的错误信息
 */
const analyzeException = (responseData) => {
    if (responseData) {
        return {
            resultCode: responseData.resultCode,
            // errMsg: errMsg ? decodeURIComponent(errMsg) : SERVICE_ERROR_STATUS[errCode]
            resultMsg: responseData.resultMsg
        };
    }
};

// 请求拦截器，每个请求发出之前需要通过此函数处理一遍
axios.interceptors.request.use(function (config) {
    config.cancelToken = new CancelToken((c) => {
        requestRecord.add(config, c);
    });
    config.baseURL = conf.baseURL;
    // 注入自定义请求头
    config.headers = Object.assign({}, config.headers, defaultHeader());
    if (config.url !== '/cs/user/loginPre' && config.url !== '/login' && config.url.indexOf('/component/serialNumber/checkSerialNumberIfExist') === -1) {
        let sessionUserStr = window.sessionStorage.getItem('currentUserInfo');
        let sessionUser = JSON.parse(sessionUserStr);
        let localUserStr = window.localStorage.getItem('currentUserInfo');
        let localUser = JSON.parse(localUserStr);
        if (localUser && sessionUser) {
            if (sessionUser.userId === localUser.userId) {
                return config;
            } else {
                window.localStorage.clear();
                window.sessionStorage.clear();
                window.localStorage.removeItem('currentUserInfo');
                window.sessionStorage.removeItem('currentUserInfo');
                Message({
                    title: '失败',
                    message: '非法请求,请重新登录',
                    type: 'error',
                    duration: 1000
                });
                window.location.href = ROUTER_BASE_PATH;
            }
        } else {
            return config;
        }
    } else if (config.url === '/loginOut') {
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.localStorage.removeItem('currentUserInfo');
        window.sessionStorage.removeItem('currentUserInfo');
    } else {
        return config;
    }
}, function (error) {
    return Promise.reject(error);
});

// 响应拦截器，从服务端获取的数据，都统一处理
axios.interceptors.response.use(function (response) {
    requestRecord.remove(response.config); // 在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除
    if (response.status === 200 && response.data) {
        // 特殊处理activti的数据接口
        let reqUrl = response.config.url;
        if (/\/app\/rest\/\w/.test(reqUrl)) {
            return response;
        }
        if (response.data.resultCode === 0) {
            if (response.config.method.toUpperCase() !== 'GET' && !hasUrlInWhiteList(response.config.url)) {
                let methodName = response.config.url.substring(response.config.url.lastIndexOf('/') + 1);
                if (!methodName.startsWith('get')) {
                    Message({
                        title: '成功',
                        message: response.data.resultMsg,
                        type: 'success',
                        duration: 1000
                    });
                }
            }
            // requestRecord.has();
            return response.data;
        } else if (response.data.resultCode === -2) {
            // window.location.href = '/';
            window.location.href = conf.routerBasePath;
        } else {
            // Message({
            //     title: '失败',
            //     message: response.data.resultMsg,
            //     type: 'error'
            // });
            return Promise.reject(analyzeException(response.data));
            // return response.data;
        }
    } else {
        return Promise.reject(analyzeException(response.data));
    }
}, function (error) {
    // console.log(error);
    // console.log('axios.interceptors.response error', JSON.stringify(error, null, 2));
    if (!error.__CANCEL__) {
        return Promise.reject(analyzeException(error.response));
    }
});

const req = (url, params, method = 'GET', headerData = {}) => {
    return new Promise((resolve, reject) => {
        let config = {
            url: url,
            method: method
        };
        if (method === 'POST' || method === 'PUT') {
            Object.assign(config, {
                data: params
            });
        } else {
            Object.assign(config, {
                params: Object.assign({}, params, {
                    t: new Date().getTime()
                })
            });
        }
        let isFormLinkLoadCacheMode = window.sessionStorage.getItem('isFormLinkLoadCacheMode');
        let isUseFormLinkCache = isFormLinkLoadCacheMode && url && (url.indexOf('getFormColumnsByFormId') !== -1 || url.indexOf('getModelFormReportList') !== -1) && !(window.location.href.indexOf('/businessSystem') !== -1 || window.location.href.indexOf('/application/model-config') !== -1 || window.location.href.indexOf('/system/employee') !== -1);
        let formLinkCacheKey = '';
        if (isUseFormLinkCache) {
            formLinkCacheKey = md5(JSON.stringify(params));
            let cacheData = window.sessionStorage.getItem(formLinkCacheKey);
            if (cacheData) {
                if (cacheData === '1') {
                    let pendingPromise = formLinkPendingMap.get(formLinkCacheKey);
                    if (pendingPromise) {
                        pendingPromise.then(resolve).catch(reject);
                        return;
                    }
                    window.sessionStorage.removeItem(formLinkCacheKey);
                } else {
                    let resultData = JSON.parse(cacheData);
                    if (Date.now() - resultData.reqTime > resultData.expired) {
                        window.sessionStorage.removeItem(formLinkCacheKey);
                    } else {
                        resolve(resultData.data);
                        return;
                    }
                }
            }
            window.sessionStorage.setItem(formLinkCacheKey, '1');
        }
        let pendingPromise = axios(config).then((data) => {
            if (data) {
                data.data && (data.data.jsessionid = data.jsessionid);
                if (isUseFormLinkCache) {
                    let cacheObj = {
                        data: data.data,
                        reqTime: Date.now(),
                        expired: 120 * 1000
                    };
                    window.sessionStorage.setItem(formLinkCacheKey, JSON.stringify(cacheObj));
                }
                return data.data;
            }
            return undefined;
        }).catch(error => {
            if (isUseFormLinkCache) {
                window.sessionStorage.removeItem(formLinkCacheKey);
            }
            if (error && error.resultMsg) {
                Message({
                    title: '失败',
                    message: error.resultMsg,
                    type: 'error'
                });
            }
            return Promise.reject(new Error(error));
        });
        if (isUseFormLinkCache) {
            formLinkPendingMap.set(formLinkCacheKey, pendingPromise);
        }
        pendingPromise.then((data) => {
            if (isUseFormLinkCache) {
                formLinkPendingMap.delete(formLinkCacheKey);
            }
            resolve(data);
        }, (error) => {
            if (isUseFormLinkCache) {
                formLinkPendingMap.delete(formLinkCacheKey);
            }
            reject(error);
        });
    });
};

export const get = function (url, params = {}, headerData) {
    return req(url, params, 'GET', headerData);
};

export const del = function (url, params = {}, headerData) {
    return req(url, params, 'DELETE', headerData);
};

export const post = function (url, params = {}, headerData) {
    return req(url, params, 'POST', headerData);
};

export const put = function (url, params = {}, headerData) {
    return req(url, params, 'PUT', headerData);
};



// WEBPACK FOOTER //
// ./src/utils/http/http-base.js